import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 25, restDelta: 0.001 });

  return (
    <motion.div
      data-testid="scroll-progress-bar"
      className="fixed top-0 left-0 right-0 h-1 z-[60] origin-left bg-gradient-to-r from-[#A67C00] via-[#D4AF37] to-[#F5D67B]"
      style={{ scaleX }}
    />
  );
};
